import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-ebay-import-tool';

export default function Example() {
  return (
    <>
      <Head>
        <title>Mercari eBay Import Tool: Your quick access from eBay to Mercari.</title>
        <meta
          name='description'
          content='Save more time and effort with Mercari’s helpful tool that lets you save time crossposting your eBay listings to Mercari.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-ebay-import-tool' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-ebay-import-tool' />
        <meta property='og:title' content='Mercari eBay Import Tool: Your quick access from eBay to Mercari.' />
        <meta
          property='og:description'
          content='Save more time and effort with Mercari’s helpful tool that lets you save time crossposting your eBay listings to Mercari.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
